import { Component, OnChanges, Input } from '@angular/core';
import { CIPDayToken, CustomerInspectionPlan } from '../../shared/misc-classes';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';
@Component({
  selector: 'app-cust-insp-pln',
  templateUrl: './cust-insp-pln.component.html',
  styleUrls: ['./cust-insp-pln.component.css']
})
export class CustInspPlnComponent implements OnChanges {
  @Input() currMonthDtObj:Date;
  @Input() cstInspPln:CustomerInspectionPlan;  
  dCIPDayTokenObj:CIPDayToken;

  constructor(private _dataService:DataService) { }

  ngOnChanges() {
    this.loadDateData();
  }

  loadDateData():void{
    if(this.cstInspPln){
      let _tmpDPHDayToken:CIPDayToken = this.cstInspPln.getDateToken(this.currMonthDtObj);
      if(_tmpDPHDayToken == null){
        this.cstInspPln.addDateToken(this.currMonthDtObj);  
        _tmpDPHDayToken = this.cstInspPln.getDateToken(this.currMonthDtObj);
      }
      this.dCIPDayTokenObj = _tmpDPHDayToken;
    }
    else{
      this.dCIPDayTokenObj = new CIPDayToken(this.currMonthDtObj,[])
    }
  }
  getProductName(_prodId:string):string{
    if(_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  getCustomerName(_custId:string):string{
    if(_custId)
      return this._dataService.getCustomerName(_custId);
    return '';
  }
  getData(option){
     if(option) return option
     return ''
  }
  getResponsiblePrsn(_prsn:string):string{
    if(_prsn) return this._dataService.getResponsiblePrsn(_prsn); 
    return ''
  }
  getTypeReady(_id:string):string{
    if(_id) return this._dataService.getTypeReady(_id)
    return ''
  }
  
  formatDate(_date:Date):string{
    if(_date)  return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    return '-';
  }

}
